<template>
    <div>
        <collegeBanner></collegeBanner>
        <div class="container">
            <div class="row">
                <div class="col-md-3">
                    <CollegeSideNavLayout></CollegeSideNavLayout>
                </div>
                <div class="col-md-9">
                    <div class="row">
                        <div class="col-md-12">
                            <div class="dash-inner-box">
                                <div class="dashboard-heading">
                                    <h1>Quiz Details</h1>
                                </div>
                                <div class="row padd-top-10">
                                    <div class="col-md-12">
                                        <div class="quizDetail">
                                            <div class="row">
                                                <div class="col-md-6 qd-info">
                                                   <h4>Quiz Name</h4>
                                                   <p>{{data.name}}</p>
                                               </div>
                                                <div class="col-md-6 qd-info">
                                                    <h4>Quiz Pools</h4>
                                                    <p class="Qpools">
                                                        <span v-for="m in data.mockAssignedQuizPools">{{m.pool_name}}</span>
                                                    </p>
                                                </div>
                                                <div class="col-md-4 qd-info">
                                                    <h4>Total Questions</h4>
                                                    <p>{{data.total_questions}}</p>
                                                </div>
                                                <div class="col-md-4 qd-info">
                                                    <h4>Min Questions</h4>
                                                    <p>{{data.min}}</p>
                                                </div>
                                                <div class="col-md-4 qd-info">
                                                    <h4>Max Questions</h4>
                                                    <p>{{data.max}}</p>
                                                </div>
                                                <div class="col-md-4 qd-info">
                                                    <h4>Set Time Duration</h4>
                                                    <p>
                                                        <span v-if="data.total_time">{{data.total_time}}, Whole Quiz</span>
                                                        <span v-else>{{data.per_question_time}}, Per Question</span>
                                                    </p>
                                                </div>
                                                <div class="col-md-4 qd-info">
                                                    <h4>Total Marks</h4>
                                                    <p>
                                                        <span v-if="data.total_marks">{{data.total_marks}}, Whole Quiz</span>
                                                        <span v-else>{{data.per_ques_marks}}, Per Question</span>
                                                    </p>
                                                </div>
                                                <div class="col-md-4 qd-info">
                                                    <h4>Negative Marking</h4>
                                                    <p>
                                                        <span v-if="data.negative_marks">{{data.negative_marks}}</span>
                                                        <span v-else>No</span>
                                                    </p>
                                                </div>
                                                <div class="col-md-6 qd-info">
                                                    <h4>Quiz for Class</h4>
                                                    <p>{{data.class}}, <span class="text-uppercase">{{data.for_sections}}</span></p>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import CollegeSideNavLayout from '../../components/CollegeSideNavLayout.vue'
    import collegeBanner from '../../components/collegeBanner'
    import axios from "axios";
    import {requestHeaders} from "../../_helpers/apiHelper";

    export default {
        components:{
            CollegeSideNavLayout,
            collegeBanner
        },
        data(){
            return{
                data:[],
            }
        },
        mounted(){
            this.getDetail();
        },
        methods:{
            getDetail() {
                var t = this;
                var url = this.$store.getters.getDomain;

                var quiz_id = t.$route.query.id;
                axios.post(`${url}api/v2/quiz/detail`, {id:quiz_id}, {headers: requestHeaders()}).then(function (response) {
                    if (response['data']['response']['status'] == 200) {
                        t.data = response['data']['response']['data'];
                    }
                });
            },
        }
    }
</script>

<style scoped>
.quizDetail{
    padding:0 20px;
}
.qd-info{
    padding: 10px 20px;

}
.qd-info h4{
    color: #fff;
    background:#00a0e3;
    font-size: 16px;
    padding:5px 10px;
    font-weight: normal;
}
.qd-info p{
    font-size: 15px;
    color: #333;
    border: 1px solid #eee;
    padding: 5px 10px;

}
table {
    width: 100%;
    border-collapse: collapse;
}
tr:nth-of-type(odd) {
    background: #f7f7f7;
}
th {
    background: #00a0e3;
    color: #fff;
    font-weight: 500;
    padding: 10px 8px;
}
td, th {
    padding: 10px 8px;
    border: 1px solid #eee;
    text-align: left;
}
.view-all{
    float: left;
}
.Qpools span:after {
    content: ", ";
}
.Qpools span:last-child:after {
    content: "";
}
@media only screen and (max-width: 760px),
(min-device-width: 768px) and (max-device-width: 1024px)  {

    /* Force table to not be like tables anymore */
    table, thead, tbody, th, td, tr {
        display: block;
    }

    /* Hide table headers (but not display: none;, for accessibility) */
    thead tr {
        position: absolute;
        top: -9999px;
        left: -9999px;
    }

    tr { border: 1px solid #ccc; }

    td {
        /* Behave  like a "row" */
        border: none;
        border-bottom: 1px solid #eee;
        position: relative;
        padding-left: 50%;
    }

    td:before {
        /* Now like a table header */
        position: absolute;
        /* Top/left values mimic padding */
        top: 6px;
        left: 6px;
        width: 45%;
        padding-right: 10px;
        white-space: nowrap;
    }

    /*
    Label the data
    */
    td:nth-of-type(1):before { content: "First Name"; }
    td:nth-of-type(2):before { content: "Last Name"; }
    td:nth-of-type(3):before { content: "Job Title"; }
    td:nth-of-type(4):before { content: "Favorite Color"; }
    td:nth-of-type(5):before { content: "Wars of Trek?"; }
    td:nth-of-type(6):before { content: "Secret Alias"; }
    td:nth-of-type(7):before { content: "Date of Birth"; }
    td:nth-of-type(8):before { content: "Dream Vacation City"; }
    td:nth-of-type(9):before { content: "GPA"; }
    td:nth-of-type(10):before { content: "Arbitrary Data"; }
}
</style>